"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.avatar.setup.title': 'Skonfiguruj Swój Awatar',
    'onboarding.avatar.config.title': 'Konfiguracja Awatara',
    'onboarding.avatar.name.label': 'Nazwa Awatara',
    'onboarding.avatar.name.placeholder': 'Wprowadź nazwę awatara',
    'onboarding.avatar.name.required': '*',
    'onboarding.avatar.age.label': 'Wiek Awatara',
    'onboarding.avatar.age.placeholder': 'Wprowadź wiek awatara',
    'onboarding.avatar.gender.label': 'Płeć Awatara',
    'onboarding.avatar.gender.placeholder': '-- Wybierz Płeć --',
    'onboarding.avatar.gender.male': 'Męska',
    'onboarding.avatar.gender.female': 'Żeńska',
    'onboarding.avatar.voice.label': 'Głos Awatara',
    'onboarding.avatar.voice.placeholder': '-- Wybierz Głos --',
    'onboarding.avatar.voice.loading': 'Ładowanie głosów...',
    'onboarding.avatar.voice.select_gender_first': 'Proszę najpierw wybrać płeć',
    'onboarding.avatar.voice.male': 'Męski',
    'onboarding.avatar.voice.female': 'Żeński',
    'onboarding.avatar.description.label': 'Opis Awatara',
    'onboarding.avatar.description.placeholder': 'Opisz osobowość i cechy swojego awatara',
    'onboarding.avatar.model.label': 'Model AI',
    'onboarding.avatar.model.help': 'Wybierz model AI, który będzie napędzał twojego awatara',
    'onboarding.avatar.image.label': 'Zdjęcie Awatara',
    'onboarding.avatar.image.placeholder': 'Wgraj zdjęcie awatara...',
    'onboarding.avatar.name': 'Nazwa Awatara',
};
